import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { PermittingHttpService } from '@core/services/http';
import { useJurisdictionTabPrefetch } from '@core/utils/hooks';
import { ContactsPlace } from '@models/enums';
import { Contacts } from '@shared/components';
import { PermittingActions } from '@store/actions';
import {
  JurisdictionSelectors,
  PermittingSelectors,
  UserSelectors,
} from '@store/selectors';
import { getJurisdictionPathParams } from '../../helpers';

export const PermittingJurisdictionContacts: FC = () => {
  const dispatch = useDispatch();
  const { jurisdictionPath } = getJurisdictionPathParams();

  const contacts = useSelector(JurisdictionSelectors.getJurisdictionContacts);
  const { contactsAccess } = useSelector(
    UserSelectors.getPermittingJurisdictionPermissions,
  );

  const isLoading = useSelector(
    PermittingSelectors.getTabLoadingState('contacts'),
  );
  const isLoaded = useSelector(
    JurisdictionSelectors.isTabDataLoaded('contacts'),
  );

  useJurisdictionTabPrefetch('contacts', jurisdictionPath);

  const fetchData = async () => {
    if (!isLoaded) {
      dispatch(
        PermittingActions.setTabLoading.done({
          tabName: 'contacts',
          isLoading: true,
        }),
      );

      await HttpService.getHttpRequests(
        PermittingHttpService,
      ).getJurisdictionContacts(jurisdictionPath);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isLoaded]);

  if (isLoading || !isLoaded) {
    return (
      <div className="prov-permitting-contacts loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="prov-permitting-contacts">
      <Contacts
        place={ContactsPlace.Permitting}
        data={contacts}
        editable={!!contactsAccess}
        hoverable={false}
      />
    </div>
  );
};
